import React from 'react';
import PropTypes from 'prop-types';

/**
 * Media - A wrapper that renders a standard HTML article with Bulma class names
 *
 * This component accepts the same props as Bloomer Media for easy migration
 */
const Media = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['media'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <article className={getClassNames()} style={style} {...props}>
      {children}
    </article>
  );
};

Media.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Media.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default Media;
